import React from "react";
import { LoaderInfo } from "src/components";
import "./info-field.scss";

interface IInfoFieldProps {
  label: string;
  value: string;
  isLoading?: boolean;
  className?: string;
}

const InfoField: React.FC<IInfoFieldProps> = ({ label, value, isLoading = false, className = "" }) => {
  return (
    <div className={`info-field ${className}`}>
      <p className="info-field-label">{label}</p>
      <div className="info-field-value">
        <LoaderInfo active={isLoading} timeout={300}>
          {value}
        </LoaderInfo>
      </div>
    </div>
  );
};

export default InfoField;
